import type { FC, HTMLAttributes, ReactNode } from "react";
import { cn } from "../utilities/cn";
import { detailHeader, detailHeaderCompact } from "../utilities/layout";

export interface DetailHeaderProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Omit bottom margin (e.g. OrderDetails). */
  compact?: boolean;
}

/**
 * Header row for split/detail panels — title left, actions right on xl+.
 */
export const DetailHeader: FC<DetailHeaderProps> = ({
  compact = false,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(compact ? detailHeaderCompact : detailHeader, className)}
    {...rest}
  >
    {children}
  </div>
);
